import { Routes, Route, Navigate } from 'react-router-dom';

import MyProductListingsContainer from './my-product-listings/MyProductListings.container';
import UploadProductListingContainer from './upload-product-listing/UploadProductListing.container';
import MyBuyerListingsContainer from './my-buyer-listings/MyBuyerListings.container';
import UploadBuyerListingContainer from './upload-buyer-listing/UploadBuyerListing.container';
import EWalletContainer from './e-wallet/EWallet.container';
import MyRewardsContainer from './my-rewards/MyRewards.container';
import DealRoomContainer from './deal-room/DealRoom.container';
import DealContainer from './deal/Deal.container';

const ShopContainer = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/shop/product-listings" />} />
      <Route path="/product-listings" element={<MyProductListingsContainer />} />
      <Route path="/upload-product-listing" element={<UploadProductListingContainer />} />
      <Route path="/upload-product-listing/:productExternalReference" element={<UploadProductListingContainer />} />
      <Route path="/buyer-listings" element={<MyBuyerListingsContainer />} />
      <Route path="/upload-buyer-listing" element={<UploadBuyerListingContainer />} />
      <Route path="/upload-buyer-listing/:productExternalReference" element={<UploadBuyerListingContainer />} />
      <Route path="/wallet" element={<EWalletContainer />} />
      <Route path="/rewards" element={<MyRewardsContainer />} />
      <Route path="/deal-room" element={<DealRoomContainer />} />
      <Route path="/deal-room/:contractExternalReference" element={<DealContainer />} />
      <Route path="/deal-room/:contractExternalReference/:chat" element={<DealContainer />} />
    </Routes>
  );
};

export default ShopContainer;
